import type { FileFormat } from '@api-client/export-center';
import { t } from '@luna/i18n';

export const getLocalizedFileFormat = (fileFormat?: FileFormat): string => {
    const map: Partial<Record<FileFormat, string>> = {
        PDF_A4: t('exportCenter.files.fileFormat.PDF_A4'),
        CSV: t('exportCenter.files.fileFormat.CSV'),
        MT942_CUMULATIVE: t('exportCenter.files.fileFormat.MT942_CUMULATIVE'),
        CAMT052: t('exportCenter.files.fileFormat.CAMT052'),
        CAMT053: t('exportCenter.files.fileFormat.CAMT053'),
        CREMUL: t('exportCenter.files.fileFormat.CREMUL'),
        MT940: t('exportCenter.files.fileFormat.MT940'),
        MT942: t('exportCenter.files.fileFormat.MT942'),
        TREASURY: t('exportCenter.files.fileFormat.TREASURY'),
        FINANCIAL_ST: t('exportCenter.files.fileFormat.FINANCIAL_ST'),
        DIRECT_DEBIT: t('exportCenter.files.fileFormat.DIRECT_DEBIT'),
        PAIN002: t('exportCenter.files.fileFormat.PAIN002'),
        PAIN002_VOP: t('exportCenter.files.fileFormat.PAIN002_VOP'),
        SPEED_COLLECT: t('exportCenter.files.fileFormat.SPEED_COLLECT'),
        SPEED_COLLECT_DAILY: t('exportCenter.files.fileFormat.SPEED_COLLECT_DAILY'),
        SPEED_COLLECT_INTRADAY: t('exportCenter.files.fileFormat.SPEED_COLLECT_INTRADAY'),
    };

    return fileFormat ? (map[fileFormat] ?? fileFormat) : '';
};
